import { Component } from '@angular/core';
import { SnackService } from '../../service/snack.service';
import { DeletionService } from '../../service/deletion.service';

@Component({
  selector: 'app-reject-deletion',
  standalone: false,
  templateUrl: './reject-deletion.component.html',
  styleUrl: './reject-deletion.component.scss'
})
export class RejectDeletionComponent {
  confirmId: string | undefined = "";
  showError: boolean = false;

  constructor(
    private snack: SnackService,
    private deletionService: DeletionService
  ) {
      this.confirmId = window.location.href.split('/').pop();
      this.confirmId = this.confirmId?.split('?')[0];
  }

  ngAfterViewInit(): void {
    console.log(this.confirmId);
    this.reject()
  }

  async reject() {
    if (!this.confirmId) {
      this.snack.error({ error: { msg: { headline: "Missing Data", text: "Deletion Rejection is not possible. Please contact the support." } } });
      return;
    }

    const result = await this.deletionService.reject(this.confirmId);

    if (
      result !== true ||
      typeof result === 'number'
    ) {
      this.showError = true;
    }
  }
}
